import React, { useState, useEffect } from 'react';
import './popup.css';

import popupImage1 from './popup1.jpeg';
import popupImage2 from './popup2.jpeg';
import popupImage3 from './popup3.jpeg';
import popupImage4 from './popup4.jpeg';

function Popup() {
  const [showPopup, setShowPopup] = useState(false);

  const popupImages = [
    popupImage1,
    popupImage2,
    popupImage3,
    popupImage4
  ];

  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * popupImages.length);
    return {
      image: popupImages[randomIndex],
      index: randomIndex
    };
  };

  const [selectedImage, setSelectedImage] = useState(() => getRandomImage());

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);

    let newIndex;

    do {
      newIndex = Math.floor(Math.random() * popupImages.length);
    } while (newIndex === selectedImage.index);

    setSelectedImage({
      image: popupImages[newIndex],
      index: newIndex
    });
  };

  if (!showPopup) {
    return null;
  }

  return (
    <div className="popup">
      <div className="popup-content">

        <span
          className="close-btn"
          onClick={closePopup}
          role="button"
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              closePopup();
            }
          }}
        >
          &times;
        </span>

        <p className="popup-text">
          Want make Money? Copy Trade!
        </p>

        <img
          src={selectedImage.image}
          alt="Popup Content"
          className="popup-image"
        />

      </div>
    </div>
  );
}

export default Popup;